import { defineStore } from 'pinia';
import cognitoRepository from '@/repositories/common/cognitoRepository';

export const useSigninMfaStore = defineStore({
    id: 'signinMfa',
    state: () => ({}),
    getters: {},
    actions: {
        /**
         * MFA暗唱コード入力処理API
         * @param {signinMfaForm} request
         * @returns response
         */
        async cognitoAuthByAuthenticationCodeAction(mfaCode) {
            try {
                const response = await cognitoRepository.loginByMfaCode(mfaCode);
                return response;
            } catch (e) {
                return e;
            }
        },
    },
});
